/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

var imageLoaded = require('lib/util/helpers').imageLoaded;

(function ($, Tc, SCS) {
	'use strict';

	var TRACKING_EVENT_ACTION = 'view';
	var TRACKING_EVENT_CATEGORY = 'slider';

	/**
	 * Wrapper for BxSlider2
	 *
	 * @author Matthias Inauen
	 * @namespace Tc.Module
	 * @class Slider
	 * @extends Tc.Module
	 */
	Tc.Module.Slider = Tc.Module.extend({
		/**
		 * Initialize Slider - only if more than one element is present
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var mod = this;

			mod.animationInterval = mod.$ctx.data('animationInterval') ? mod.$ctx.data('animationInterval') : 0;
			mod.loopAround = mod.$ctx.data('loopAround') ? true : false;
			mod.startIndex = mod.$ctx.data('startIndex') ? (parseInt(mod.$ctx.data('startIndex'), 10) - 1) : 0;
			mod.deepLinking = mod.$ctx.data('deepLinking') ? true : false;
			mod.sliderId = mod.$ctx.data('sliderId');
			mod.isMobile = $(document.body).hasClass('is-mobile');
			mod.videoVolume = mod.$ctx.find('.video-volume');
			mod.slides = mod.$ctx.find('ul.bx-slider .modSlide');
			mod.disableTracking = mod.$ctx.data('disable-tracking');
			mod.trackingLocation = mod.$ctx.data('event-location');
			mod.trackingStarted = false;
			mod.noControlsFadeout = mod.$ctx.data('no-controls-fadeout');
			mod.controls = {};
			mod.componentInitialized = false;
			mod.redrawDebounceTimer = 0;

			if (mod.slides.length <= 1) {
				mod.$ctx.addClass('no-controls');
			}

			mod.controlsEnabled = !mod.$ctx.hasClass('no-controls');

			if (mod.deepLinking && mod.sliderId) {
				var deepLinkValue = parseInt(SCS.HashDeepLink.get(mod.sliderId), 10) - 1; // make base 0
				mod.startIndex = (deepLinkValue) ? parseInt(deepLinkValue, 10) : mod.startIndex;
				// make sure start index is not larger than amount of slides available
				mod.startIndex = (mod.startIndex >= mod.$ctx.find('.modSlide').length) ? 0 : mod.startIndex;
			}

			// subscribe to my own channel, so others can communicate back
			this.sandbox.subscribe('SLIDER', this);
			var uuid = Math.floor((Math.random() * 100000000000)) + '-' + Math.floor((Math.random() * 100000000000));
			this.$ctx.attr('data-id', uuid);
			if(this.$ctx.hasClass('sdx') && !this.$ctx.hasClass('fullbleed')) {
				var elemWidth = this.$ctx.parent().width();
				var $customStyle = $('<style>[data-id="' + uuid + '"] .bx-wrapper { width: ' + elemWidth + 'px; } </style>');
				this.$ctx.prepend($customStyle);
			}

			this.initSlider();
			// controls only exist after slider is initialized.
			mod.controls = mod.$ctx.find('.bx-controls');
			mod.addEventListeners();

			mod.$ctx.removeClass('not-initialized');

			callback();
		},

		initSlider: function () {
			var options = {
				pause: (this.animationInterval * 1000),
				speed: 300,
				startSlide: this.startIndex,
				infiniteLoop: this.loopAround,
				auto: (this.animationInterval > 0),
				preloadImages: 'visible',
				hideControlOnEnd: true,
				nextText: '',
				prevText: '',
				touchEnabled: this.controlsEnabled && this.isMobile,
				useCSS: false, // true will kill the loop around feature.
				responsive: true,
				adaptiveHeight: false,
				onSlideBefore: $.proxy(this.handleBeforeSlide, this),
				onSliderLoad: $.proxy(this.lazyLoadFirstItem, this)
			};

			if (this.deepLinking && this.sliderId) {
				options.onSlideAfter = $.proxy(this.setDeepLink, this);
			}

			this.slider = $('ul.bx-slider', this.$ctx).bxSlider(options);
		},

		lazyLoadFirstItem: function () {
			var index = this.startIndex,
				mod = this;
			// bx slider in infinite loop mode, will clone the first and last item
			if (mod.loopAround) {
				// let's preload the cloned elements to allow for smooth looping transition.
				mod.$ctx.find('.bx-clone').each(function () {
					mod.handleBeforeSlide($(this));
				});
			}

			mod.handleBeforeSlide(mod.slides.eq(index));
			// make sure the initialization ends first.
			this.componentInitialized = true;
			setTimeout(function () {
				mod.fire('sliderSlideInitialized', {index: mod.startIndex, sliderId: mod.sliderId, slideId: mod.slides.eq(index).data('id')}, ['SLIDER']);
				if (!mod.disableTracking && !mod.animationInterval && mod.slides.length > 1) {
					mod.trackingStarted = true;
					if (SCS && SCS.portal && SCS.portal.datalayer) {
						SCS.portal.datalayer.trackEvent(TRACKING_EVENT_ACTION, mod.slides.eq(index).data('event-label'), mod.trackingLocation, TRACKING_EVENT_CATEGORY);
					}
				}
			}, 0);
		},

		/**
		 * Lazy load all images just before switching to new slide.
		 * @param $slideElement
		 * @param oldIndex
		 * @param newIndex
		 */
		handleBeforeSlide: function ($slideElement, oldIndex, newIndex) {
			var image = $slideElement.find('img');

			if (image.length) {
				if (!this.isMobile) {
					this.stopAllVideos();
					this.loadVideo(image);
				}

				this.loadImage(image);
			}

			this.fireSliderSlideChanged($slideElement.data('id'), newIndex);
		},

		/**
		 * lazy load the image if the image does not have a src set yet.
		 * @param image
		 */
		loadImage: function (image) {
			var url;

			if (image.attr('src').length === 0) {
				if (this.isMobile) {
					url = image.data('m-image') ? image.data('m-image') : image.data('d-image');
				} else {
					url = image.data('d-image');
				}

				image.attr('src', url).one('load', $.proxy(this.handleResize, this));
			}
		},

		loadVideo: function (image) {
			var videoUrl = image.data('video'),
				mod = this,
				disableLoop = image.data('disable-loop'),
				showPoster = image.data('show-poster');

			if (image.parent().is('video')) {
				this.unPauseVideo(image.parent().get(0));
			}
			else if (videoUrl && videoUrl.length > 0) {
				var url;
				if (showPoster) {
					if (this.isMobile) {
						url = image.data('m-image') ? image.data('m-image') : image.data('d-image');
					} else {
						url = image.data('d-image');
					}
				}
				image.wrap('<video muted="muted" ' + (disableLoop ? '' : 'loop="true"') +
					(showPoster ? ' poster="' + url + '"' : '') +
					' src="' + videoUrl + '"></video>');
				// loop = true, for browser that support that attribute, like safari iPad
				// for browsers that don't support the loop attribute, wait for the ended event and restart.
				// loop = true will loop before calling the ended event, hence this will never be called in that case.
				if(!disableLoop) {
					image.parent('video').on('ended', function () {
						mod.playVideoFromStart(this);
					});
				}
				// update video list
				this.videos = this.$ctx.find('video');

				this.playVideoFromStart(image.parent().get(0));
			}
		},

		stopAllVideos: function () {
			if (this.videos) {
				this.videos.each(function () {
					this.pause();
				});
			}
		},

		playVideoFromStart: function (videoDomEl) {
			videoDomEl.load();
			videoDomEl.play();
		},

		unPauseVideo: function (videoDomEl) {
			videoDomEl.play();
		},

		handleResize: function () {
			this.redraw();
		},

		handleOrientationChange: function () {
			if (this.slider) {
				this.slider.parent().css('height', 'auto');
				this.redraw();
			}
		},

		handleMouseEnter: function () {
			this.showHideControl(0, 300, 1);
			this.startStopAutoPlay(false);
		},

		handleMouseLeave: function () {
			this.showHideControl(750, 500, 0);
			this.startStopAutoPlay(true);
		},

		handleTouchStart: function () {
			this.showHideControl(0, 100, 1, 150);
			this.startStopAutoPlay(false);
		},

		handleTouchEnd: function () {
			this.showHideControl(500, 350, 0, 150);
			this.startStopAutoPlay(true);
		},

		handleVideoVolume: function (event) {
			var button = $(event.currentTarget),
				slide = button.closest('.modSlide'),
				video = slide.find('video').eq(0).get(0);

			if (button.is('.video-volume-off') || button.is('.video-volume-on')) {
				video.muted = !video.muted;
				button.addClass('hidden');
				button.siblings('button').removeClass('hidden');
			}
		},

		startStopAutoPlay: function (startAuto) {
			if (!this.animationInterval || this.animationInterval <= 0) {
				return;
			}

			if (startAuto) {
				this.slider.startAuto();
			}
			else {
				this.slider.stopAuto();
			}
		},

		setDeepLink: function ($sliderItem, oldIndex, newIndex) {
			SCS.HashDeepLink.set(this.sliderId, (newIndex + 1));
		},

		/**
		 * Does the show hide animation of the controls ui.
		 * @param delay - in ms
		 * @param duration - in ms
		 * @param alpha - from 0 - 1
		 * @param startDelay - in ms
		 */
		showHideControl: function (delay, duration, alpha, startDelay) {
			var mod = this;
			startDelay = startDelay || 0;
			if (this.controlsEnabled) {
				setTimeout(function () {
					mod.controls.stop(true).delay(delay).fadeTo(duration, alpha);
				}, startDelay);
			}
		},

		addEventListeners: function () {
			if (!this.noControlsFadeout) {
				this.$ctx.on('mouseenter', $.proxy(this.handleMouseEnter, this));
				this.$ctx.on('mouseleave', $.proxy(this.handleMouseLeave, this));

				$(document.body).on('touchstart', $.proxy(this.handleTouchStart, this));
				$(document.body).on('touchend', $.proxy(this.handleTouchEnd, this));
			}

			if (!this.isMobile) {
				$(window).on('resize', $.proxy(this.handleResize, this));
			} else {
				$(window).on('orientationchanged', $.proxy(this.handleOrientationChange, this));
			}


			// Redraw slider after all slider images are (lazy)loaded
			Promise.all(this.$ctx.find('img').get().map(imageLoaded)).then(this.redraw.bind(this, true));

			this.videoVolume.on('click', '.video-volume-on, .video-volume-off', $.proxy(this.handleVideoVolume, this));
		},

		/**
		 * Find the slide with slideId and make it the active slide
		 * @param slideId
		 */
		gotoSlideWithId: function (slideId) {
			var mod = this;
			if (slideId) {
				mod.slides.each(function (index, slide) {
					if ($(slide).data('id') === slideId) {
						mod.slider.goToSlide(index);
						mod.fireSliderSlideChanged(slideId, index);
						return false;
					}
				});
			}
		},

		/**
		 * Fires Terrific event sliderSlideChanged
		 *
		 * @param slideId string
		 * @param newIndex number
		 */
		fireSliderSlideChanged: function (slideId, newIndex) {
			this.fire('sliderSlideChanged', {index: newIndex, sliderId: this.sliderId, slideId: slideId}, ['SLIDER']);
			if (this.trackingStarted) {
				if (SCS && SCS.portal && SCS.portal.datalayer) {
					SCS.portal.datalayer.trackEvent(TRACKING_EVENT_ACTION, this.slides.eq(newIndex).data('event-label'), this.trackingLocation, TRACKING_EVENT_CATEGORY);
				}
			}
		},

		/**
		 * Terrific message handler to auto scroll to slide
		 * @param data      requires a slideId attribute, that is either e single slideId or an array of slideIds
		 */
		onSliderGotoSlide: function (data) {
			var mod = this;
			var slideId = data.slideId;

			if (slideId) {
				if ($.isArray(slideId)) {
					for (var i = 0; i < slideId.length; i += 1) {
						mod.gotoSlideWithId(slideId[i]);
					}
				}
				else if ($.type(slideId) === 'string') {
					mod.gotoSlideWithId(slideId);
				}
			}
		},

		redraw: function(lazy) {
			var mod = this;
			if (this.slider) {
				var redraw = function() {
					mod.$ctx.addClass('redrawing');
					mod.$ctx.find('.bx-viewport').css('height', '');
					mod.slider.parent().css('height', 'auto');
					mod.slider.redrawSlider();
					mod.$ctx.removeClass('redrawing');
				}
				if (lazy) {
					// Clear pending timer
					if (this.redrawDebounceTimer) {
						clearTimeout(this.redrawDebounceTimer);
					}
					this.redrawDebounceTimer = setTimeout(redraw, 50);
				} else {
					redraw();
				}
			}
		}
	});
})(window.Tc.$, window.Tc, window.SCS = window.SCS || {});

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/base/clientlibs/shared/js/modules/Tc.Module.Slider.js
// module id = 91
// module chunks = 0